import { i18nTranslate } from 'src/utils'
import { getTeamStatus } from './fixture'

const createFormInput = data => {
  const { renderPropArray, costCenterList } = data
  const formInput = [
    [
      {
        name: 'teamName',
        type: 'text',
        placeholderKey: 'teamNamePlaceholder',
        columnType: {
          lg: '4',
        },
        customClassName: 'mb-1',
        dataTestId: 'qa-dropdown',
      },
      {
        name: 'costCenter',
        type: 'select',
        options: costCenterList,
        columnType: {
          lg: '4',
        },
        customClassName: 'mb-1',
        dataTestId: 'qa-dropdown',
      },
      {
        name: 'addCostCenter',
        isToHideLabel: true,
        type: 'link',
        columnType: {
          lg: '4',
        },
        customClassName:
          'add-cost-center px-2 mt-4 px-md-5 d-flex align-items-center',
        RenderProps: renderPropArray[0],
      },
    ],
    [
      {
        name: 'description',
        placeholderKey: 'descriptionPlaceholder',
        type: 'textarea',
        dataTestId: 'qa-team-description-input',
        columnType: {
          lg: '12',
          md: '12',
        },
      },
    ],
  ]
  return formInput
}

const filterTeamsInput = props => {
  const {
    defaultSearchTerm,
    defaultSearchStatus,
    defaultSearchCostCenter,
    costCenterList,
  } = props

  return [
    {
      name: 'searchTerm',
      type: 'search',
      dataTestId: 'qa-search',
      placeHolderText: i18nTranslate('teamManagement.search', 'Search Team'),
      columnType: {
        lg: '6',
        md: '12',
      },
      customClassName: 'pr-0 pr-lg-2',
      defaultValue: defaultSearchTerm,
    },
    {
      name: 'selectTeamStatus',
      type: 'select',
      label: i18nTranslate('selectStatus', 'Status'),
      options: getTeamStatus({ isSearchStatusForm: true }),
      dataTestId: 'qa-team-management-status',
      columnType: {
        lg: '3',
        md: '6',
        xs: '6',
      },
      customClassName: 'pr-2 pr-lg-2 pr-md-2 pr-sm-2',
      defaultValue: defaultSearchStatus,
    },
    {
      name: 'selectCostCenter',
      type: 'select',
      label: i18nTranslate('selectCostCenter', 'Cost Center'),
      options: costCenterList,
      dataTestId: 'qa-dropdown',
      columnType: {
        lg: '3',
        md: '6',
        xs: '6',
      },
      defaultValue: defaultSearchCostCenter,
    },
  ]
}

export { createFormInput, filterTeamsInput }
